import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
  initReportInfo,
  requestReportStart,
  requestReportSuccess,
  requestReportFail,

  createReportStart,
  createReportSuccess,
  createReportFail,
} from '../actions/report';

import requestManagement from '../service/requestManagement';
const { method_POST, method_GET } = requestManagement;

import CONFIG from '@root/config/config.next';
const url = CONFIG.backendEndpoint;

export function* requestReport({ payload }) {

  console.log('[sages] requestReport : ', payload);

  const apiURL = `${url}/backend/v2/report/list`;

  //====================================================================================================================

  try {
    const data = yield method_GET({ url: apiURL, params: payload?.params });

    /*console.log("[API] GET : ",);*/

    yield put(requestReportSuccess(data));

  } catch (error) {
    yield put(requestReportFail(error));
  }

  //====================================================================================================================

}

export function* generatedReport({ payload = {} }) {

  console.log('[sages] generatedReport 1 : ', payload);

  const apiURL = `${url}/backend/v2/report/${payload?.type}`;

  //====================================================================================================================

  try {

    const data = yield method_POST({
      url: apiURL,
      data: payload?.data,
    });

    console.log('[sages] generatedReport: 2 ', data);

    yield put(createReportSuccess(data));

  } catch (error) {

    console.log('[sages] generatedReport: 3 [error]', { error });
    yield put(createReportFail(error));
  }

  //====================================================================================================================
}

export function* watchReport() {

  /*console.log('[sages] watchReport : ✅');*/

  yield all([
    takeLatest(requestReportStart, requestReport),
    takeLatest(createReportStart, generatedReport),
  ])
}



